import React from "react";

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      error: false,
    };
    this.imgRef = null;
    this.observer = null;
    this.setImgRef = (element) => {
      this.imgRef = element;
      
      // Setup Intersection Observer when ref is available
      if (element && "IntersectionObserver" in window && !this.observer) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.loadImage();
                if (this.observer) {
                  this.observer.unobserve(entry.target);
                }
              }
            });
          },
          {
            rootMargin: "50px", // Start loading 50px before image enters viewport
          }
        );
        this.observer.observe(element);
      } else if (!element && this.observer) {
        // Cleanup observer when element is removed
        this.observer.disconnect();
        this.observer = null;
      }
    };
  }

  componentDidMount() {
    // Fallback for browsers without IntersectionObserver
    if (!("IntersectionObserver" in window)) {
      this.loadImage();
    }
  }

  componentWillUnmount() {
    // Cleanup observer on unmount
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  loadImage = () => {
    const img = new window.Image();
    img.onload = () => {
      this.setState({ loaded: true });
    };
    img.onerror = () => {
      this.setState({ error: true });
    };
    img.src = this.props.src;
  };

  render() {
    var className = "image " + (this.props.className || "");
    var height = this.props.height ? this.props.height : "auto";
    var width = this.props.width || "100%";
    var caption = "";

    if (this.props.caption) {
      caption = <div className="caption">{this.props.caption}</div>;
    }

    const backgroundImageStyle = this.state.loaded
      ? { backgroundImage: `url(${this.props.src})` }
      : {};

    return (
      <div
        ref={this.setImgRef}
        style={{
          ...backgroundImageStyle,
          height: `${height}`,
          width: `${width}`,
          backgroundColor: this.state.loaded ? "transparent" : "#f0f0f0",
        }}
        className={className}
      >
        {caption}
        {/* Hidden img for lazy loading with proper attributes */}
        <img
          src={this.state.loaded ? this.props.src : undefined}
          alt={this.props.alt || ""}
          // loading="lazy"
          style={{ display: "none" }}
          width={this.props.width}
          height={this.props.height}
        />
      </div>
    );
  }
}
export default Image;



// WEBPACK FOOTER //
// ./src/components/Image.js